<template>
  <v-form @submit.prevent="handlerContinue">
    <v-row :class="!mdAndUp ? 'd-flex flex-column' : ''">
      <v-col md="3" sm="12">
        <v-card :class="['rounded-lg', mdAndUp && 'mr-3 mb-12']" elevation="0">
          <v-card-title>
            <v-icon class="mr-2">mdi-basket-outline</v-icon>
            Monte seu Combo
          </v-card-title>
          <v-card-subtitle class="ml-1">
            Adicione os eventos que irão compor seu combo.
          </v-card-subtitle>
          <v-card-text>
            <v-expand-transition>
              <v-badge
                bordered
                overlap
                color="green"
                :content="quantityProducts"
                v-if="hasProducts"
              >
                <v-btn
                  color="primary"
                  class="rounded-lg"
                  @click="toggleCartModal"
                >
                  Acessar os eventos
                  <v-icon> mdi-cart-outline </v-icon>
                </v-btn>
              </v-badge>
            </v-expand-transition>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="9" sm="12">
        <v-card class="rounded-lg mb-12" elevation="0">
          <v-col md="12" sm="12" class="pt-0">
            <v-card-title class="text-h6">
              <v-icon class="mr-2"> mdi-store-outline </v-icon>
              Eventos
              <v-spacer></v-spacer>
              <BaseTextField
                append-icon="mdi-magnify"
                single-line
                style="width: 300px"
                placeholder="Pesquisar"
                v-model="search"
              ></BaseTextField>
            </v-card-title>
            <v-card-text>
              <v-row class="pt-3" v-if="productsLoading">
                <v-col v-for="index in 20" :key="index" cols="2">
                  <v-skeleton-loader type="card"></v-skeleton-loader>
                </v-col>
              </v-row>
              <v-row v-else-if="hasntProducts">
                <v-col>
                  <v-card-text class="text-h6">
                    Nenhum evento encontrado
                  </v-card-text>
                </v-col>
              </v-row>
              <v-row class="pt-3" v-else>
                <card-products
                  :products="filtredProducts"
                  :cols="12"
                  :lg="2"
                  :md="2"
                  :sm="4"
                />
              </v-row>
            </v-card-text>
          </v-col>
        </v-card>
      </v-col>
    </v-row>
    <v-card-actions v-if="getComboType === 'new'">
      <v-spacer></v-spacer>
      <v-btn @click="backStep" text class="rounded-lg"> Voltar </v-btn>
      <v-btn color="primary" type="submit" class="rounded-lg"> Continue </v-btn>
    </v-card-actions>
    <products-cart />
    <events-soldout-modal
      :events="eventSoldout"
      :title="`Os seguintes eventos estão esgotados:`"
      @removeEvents="handlerContinue"
    />
  </v-form>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import displayHelpers from "@/mixins/breakpoints.mixins";
import cardProducts from "@/components/produtos/combos/products/cardProducts.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import productsCart from "@/components/produtos/combos/products/productsCart.vue";
import eventsSoldoutModal from "@/components/produtos/combos/products/eventsSoldoutModal.vue";

export default {
  name: "descriptionCombo",
  mixins: [displayHelpers],
  components: {
    cardProducts,
    productsCart,
    BaseTextField,
    eventsSoldoutModal,
  },
  data() {
    return {
      search: "",
      eventSoldout: [],
    };
  },
  computed: {
    ...mapGetters([
      "getCart",
      "getItens",
      "getProducts",
      "productsLoading",
      "comboModal",
      "productsToFind",
      "getComboType",
    ]),
    filtredProducts() {
      return this.getProducts.filter(product =>
        product?.descricao?.toLowerCase().includes(this.search?.toLowerCase())
      );
    },
    hasProducts() {
      return this.getCart.length > 0;
    },
    hasntProducts() {
      return !this.productsLoading && this.filtredProducts.length === 0;
    },
    quantityProducts() {
      return this.getCart.length;
    },
  },
  methods: {
    ...mapActions([
      "saveProducts",
      "backStep",
      "getProductsCombo",
      "toggleCartModal",
      "addCartEdit",
      "showSnackbarError",
    ]),
    handlerContinue() {
      if (this.getCart.length === 0) {
        this.showSnackbarError("Adicione pelo menos um evento");
        return false;
      }
      this.eventSoldout = [];
      this.getCart.forEach(product => {
        if (product?.quantityPossibilities) {
          if (
            product.quantityPossibilities.some(
              variation => variation.status === "ESGOTADO"
            )
          ) {
            this.eventSoldout.push(product);
          }
        } else if (product.status === "ESGOTADO") {
          this.eventSoldout.push(product);
        }
      });

      const hasSoldout = this.getCart.some(product => {
        if (product?.quantityPossibilities) {
          return product.quantityPossibilities.some(variation => {
            if (variation.status === "ESGOTADO") {
              return true;
            }
            return false;
          });
        } else if (product.status === "ESGOTADO") {
          return true;
        }
        return false;
      });

      if (hasSoldout) {
        return false;
      }
      this.saveProducts();
      return true;
    },
    async productsSelected(val) {
      await this.getProductsCombo();
      if (val && this.getComboType === "edit") {
        const idprodutos = this.productsToFind[0].idprodutos?.split(",") || [];
        const idprodutos_variacoes =
          this.productsToFind[0].idproduto_variacoes?.split(",") || [];
        const qtd = this.productsToFind[0].qtd?.split(",") || [];
        const qtd_variacao =
          this.productsToFind[0].qtd_variacao?.split(",") || [];
        const preco_prod = this.productsToFind[0].preco_prod?.split(",") || [];
        const preco_var = this.productsToFind[0].preco_var?.split(",") || [];
        const slug_var = this.productsToFind[0].slug_var?.split(",") || [];
        const slug_prod = this.productsToFind[0].slug_prod?.split(",") || [];

        const productInCart = this.getProducts
          .map(product => {
            if (
              product.variantes &&
              product.variantes.variacoes_produto &&
              product.variantes.variacoes_produto.length > 0
            ) {
              const foundVariations = product.variantes.variacoes_produto
                .map(variation => {
                  const index = idprodutos_variacoes.indexOf(
                    variation.idproduto_variacao
                  );
                  if (index !== -1) {
                    return {
                      ...variation,
                      quantity: qtd_variacao[index],
                      variationPrice: preco_var[index],
                      total: qtd_variacao[index] * preco_var[index],
                      slug: slug_var[index],
                    };
                  }
                  return null;
                })
                .filter(Boolean);

              if (foundVariations.length > 0) {
                return {
                  ...product,
                  descricao: product.descricao,
                  img: product.imagens?.imagem1,
                  idproduto_variacao: foundVariations.map(
                    variation => variation.idproduto_variacao
                  ),
                  total: foundVariations.reduce(
                    (acc, curr) => acc + curr.total,
                    0
                  ),
                  quantityPossibilities: foundVariations,
                };
              }
            } else if (idprodutos.includes(product.idproduto)) {
              // Adiciona o produto diretamente se não houver variações, mas está em idprodutos
              return {
                ...product,
                img: product.imagens?.imagem1,
                quantity: qtd[idprodutos.indexOf(product.idproduto)],
                quantityIfOnlyQuantity:
                  qtd[idprodutos.indexOf(product.idproduto)],
                newPrice: preco_prod[idprodutos.indexOf(product.idproduto)],
                slug: slug_prod[idprodutos.indexOf(product.idproduto)],
                total:
                  qtd[idprodutos.indexOf(product.idproduto)] *
                  preco_prod[idprodutos.indexOf(product.idproduto)],
              };
            }

            return null;
          })
          .filter(Boolean); // Remove os elementos nulos

        this.addCartEdit(productInCart);
      }
    },
  },
  watch: {
    comboModal(val) {
      this.productsSelected(val);
    },
  },
  mounted() {
    this.productsSelected(this.comboModal);
  },
};
</script>
